import { BusinessRole, MaterialCategoryName } from "fe-shared/src/types/domain";
import { ICellRendererParams } from "@ag-grid-community/core";
import {
  Transaction,
  TransactionMaterial,
  TransactionType,
  Transfer,
} from "../types";
import getMaterialGroups from "./materialsConverter";

const DELIVERY_RECEIPT_TRANSACTIONS = [
  TransactionType.Delivery,
  TransactionType.Receipt,
];

export const isTransactionWithWeightAndScale = (transaction: Transaction) => {
  const {
    transactionType,
    sourceWarehouse,
    targetWarehouse,
    linkedTransactions,
  } = transaction;
  const isSourceHauler =
    sourceWarehouse?.participant?.businessRoleCode === BusinessRole.Hauler;
  const isTargetProcessor =
    targetWarehouse?.participant?.businessRoleCode === BusinessRole.Processor;
  const isDeliveryOrReceipt =
    (transactionType === TransactionType.Adjustment &&
      linkedTransactions.some((t) =>
        DELIVERY_RECEIPT_TRANSACTIONS.includes(t.transactionType)
      )) ||
    DELIVERY_RECEIPT_TRANSACTIONS.includes(transactionType);

  return isSourceHauler && isTargetProcessor && isDeliveryOrReceipt;
};

export const getMaterialTotals = (materials: TransactionMaterial[]) =>
  getMaterialGroups(materials).reduce((result, mg) => {
    result[mg.materialCategoryName] = Math.round(
      mg.items.reduce((sum, i) => sum + i.units.unitQuantity, 0)
    );
    return result;
  }, {} as { [key in MaterialCategoryName]: number });

export function isTransaction(
  item: Transaction | Transfer
): item is Transaction {
  return "transactionType" in item;
}

export const getTransactionRowHeight = (params: ICellRendererParams) => {
  const linkedTransactions = params.data?.linkedTransactions || [];
  const additionalLinkedNumber = Math.max(linkedTransactions.length - 1, 0);
  const linkedTransactionHeight = 16;
  const additionalHeight = additionalLinkedNumber * linkedTransactionHeight;

  return 52 + additionalHeight;
};

export default isTransactionWithWeightAndScale;
